module.exports = __webpack_public_path__ + "img/wordpress.e6784ef5.svg";